import { formatNumber } from "utils";

export const zeroReturn = "--";

/**
 *
 * @param digits 数组
 * @param unit 单位
 * @param param2  { debugTag?: string, isZeroValid?: boolean }
 * @returns { data: string, isSuccess: boolean, unit: string, negative: boolean }
 */
export function formatDisplay(
  digits: (string | undefined)[],
  unit: string,
  options?: { debugTag?: string; isZeroValid?: boolean; decimals?: number },
) {
  const { isZeroValid = true, decimals = 1 } = options || {};
  if (!digits?.length) {
    return {
      data: zeroReturn,
      isSuccess: false,
      unit: undefined,
    };
  }
  //
  for (let i = 0; i < digits.length; i++) {
    if (!digits[i]) {
      continue;
    }
    if (isZeroValid && Number(digits[i]) === 0) {
      return {
        data: 0,
        isSuccess: true,
        unit,
        negative: false,
      };
    }

    const formatResult = formatNumber(Number(digits[i] || "0"), decimals, {
      formatAll: true,
      zeroReturn: zeroReturn,
    });

    if (formatResult !== zeroReturn) {
      return {
        data: formatResult,
        isSuccess: true,
        unit: unit,
        negative: digits[i]?.startsWith("-"),
      };
    }
  }

  return {
    data: zeroReturn,
    isSuccess: false,
    unit: undefined,
  };
}

/**
 * 判断字符串是否为0 加个变化、价格必须是有意义的数字
 * @param value
 * @returns
 */
export function isStringNotZero(value?: string) {
  if (!value) {
    return false;
  }
  return Number(value) !== 0;
}

export function isStringZero(value?: string) {
  if (!value) {
    return false;
  }
  return Number(value) === 0;
}

/**
 * 接口返回的字符串是否为 "null" 或 "undefined"
 * @param value
 * @returns
 */
export function isStringNull(value?: string) {
  return !value || value === "null" || value === "undefined";
}

/**
 * 用于处理涨跌幅数据
 */

export function formatPriceChange(value?: string) {
  const showZero = isStringZero(value ?? "");
  const priceChange = Number(value || "0");
  const finalShowZero = showZero || Math.abs(priceChange) < 0.01;
  const isString = isStringNull(value ?? "");
  const formattedValue = isString
    ? "--"
    : `${priceChange > 0 ? "+" : ""}${((Math.floor(Math.abs(priceChange) * 100) / 100) * Math.sign(priceChange)).toFixed(2)}%`;

  return {
    formattedValue,
    finalShowZero,
    isEmpty: isString,
    priceChange,
  };
}

export const formatThousands = (s: string) => {
  const [sign, digits] = s.startsWith("-") ? ["-", s.slice(1)] : ["", s];
  return sign + digits.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
